module.exports = __webpack_public_path__ + "img/symbol_10.61f821ad.png";